const Button = {
  variants: {
    primary: {
      bg: "lime", // Default color
      color: "pureBlack",
      borderColor: "limeShade.500",
      _hover: {
        bg: "limeShade.300",
        borderColor: "limeShade.500"
      },
      _disabled: {
        bg: "limeShade.100",
        borderColor: "limeShade.200"
      }
    },
    secondary: {
      bg: "transparent", // Default color
      color: "limeShade.950",
      border: "1px solid",
      borderColor: "limeShade.950",
      _hover: {
        bg: "limeShade.50",
        borderColor: "limeShade.500"
      },
      _disabled: {
        bg: "limeShade.100"
      }
    },
    darkTeal: {
      bg: "darkTeal",
      color: "white",
      _hover: {
        bg: "teal"
      },
      _disabled: {
        bg: "limeShade.100",
        borderColor: "limeShade.200"
      }
    }
  },
  defaultProps: {
    // variant: "primary"
  }
};

export default Button;